import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import { Grid } from "@material-ui/core";
import React from "react";
import { IndicadorFlat } from "../../components/Indicador";
import { Reais } from "../../components/numberUtils";
import { DashPanel } from "../dashboard/DashPanel";
import { AReceberVendaPrazo, EmAtraso } from "./models";

function truncateString(str: string, num: number) {
  if (str.length > num) {
    return str.slice(0, num) + "...";
  } else {
    return str;
  }
}

export const ListItemClienteEmAtraso = (props: EmAtraso) => {
  return (
    <div key={props.id}>
      <ListItem>
        <ListItemAvatar>
          <Avatar
            variant="rounded"
            style={{ backgroundColor: "orange", fontSize: "0.7rem" }}
          >
            {props.id}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          secondary={
            <span style={{ fontSize: "0.8rem" }}>
              {" "}
              {truncateString(props.nome, 20)}
            </span>
          }
        ></ListItemText>
        <ListItemText
          style={{ textAlign: "right" }}
          secondary={<span> {props.compras} compra(s) </span>}
        >
          <b style={{ fontSize: "1.1rem" }}>
            <Reais valor={props.saldo} />{" "}
          </b>
        </ListItemText>
      </ListItem>
      <Divider />
    </div>
  );
};

export const PanelClientesEmAtraso = (props: AReceberVendaPrazo) => {
  return (
    <DashPanel title="Clientes em Atraso (Fat. Anterior)">
      <Grid
        container
        justifyContent="space-between"
        style={{
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingBottom: "8px",
        }}
      >
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Pago"
            r$
            valor={props.faturamentoAnterior.pago}
            showDecimals={false}
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Pendências"
            r$
            valor={props.faturamentoAnterior.pendente}
            showDecimals={false}
          />
        </Grid>
      </Grid>

      <List>
        {props.faturamentoAnterior.emAtraso.map((x) => (
          <ListItemClienteEmAtraso key={x.id} {...x} />
        ))}
      </List>
    </DashPanel>
  );
};
